<template>
  <ul class="modal-list-photos">
    <li class="modal-list-photos__item" v-for="photo in photos" :key="photo.picture_timestamp">
        <el-popover
          trigger="hover"
        >
          <div class="modal-list-photos__info">
              <p>
                  {{photo.driver}}
              </p>
                <p>
                  {{photo.side}}
              </p>
              <p>
                  Taken:
                  <br />
                  <span>
                      {{photo.picture_timestamp}}
                  </span>
              </p>
          </div>
            <a class="modal-list-photos__link" slot="reference" :href="photo.picture_url" target="_blank">
                <img class="modal-list-photos__img" :src="photo.picture_url" alt="file photo">
            </a>
        </el-popover>
    </li>
  </ul>
</template>

<script>

export default {
  name: "PhotosList",
  props: {
    photos: {
      type: Array,
      required: true,
    }
  },
}
</script>

<style>
.modal-list-photos {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 0;
    list-style-type: none;
    margin: -5px;
    box-sizing: border-box;

}
.modal-list-photos__item {
    width: calc(100% / 5 );
    padding: 5px;
    box-sizing: border-box;
}

.modal-list-photos__link {
  display: block;
}

 .modal-list-photos__img {
    width: 100%;
    height: auto;
}

@media only screen and (max-width: 930px) {
  .modal-list-photos__item {
        width: calc(100% / 4 );
    }
}

@media only screen and (max-width: 700px) {
    .modal-list-photos__item {
        width: calc(100% / 3 );
    }
}

@media only screen and (max-width: 500px) {
    .modal-list-photos__item {
        width: calc(100% / 2 );
    }
}
@media only screen and (max-width: 400px) {
    .modal-list-photos__item {
        width: 100%;
    }
}

.modal-list-photos__info {
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    color: #000000;
}
@media only screen and (max-width: 500px) {
    .modal-list-photos__info {
        font-size: 16px;
    }
}

</style>